import React, { useState, useEffect } from 'react';
import { useAuth } from '../../contexts/AuthContext';
import { useFirestore } from '../../contexts/FirestoreContext';
import { getDoc, doc } from 'firebase/firestore';
import { Card, Row, Col, Tabs, Tooltip } from 'antd';
import { TeamOutlined } from '@ant-design/icons';
import { createIncidentLog, ACTIVITY_TYPES } from '../../utils/activityLogger';
import BulkSMSPanel from '../admin/BulkSMSPanel';

const { TabPane } = Tabs;

const CommsTab = ({ incidentId }) => {
  const { currentUser } = useAuth();
  const { db } = useFirestore();
  const [userOrgId, setUserOrgId] = useState(null);
  const [activeTab, setActiveTab] = useState('bulk_sms');

  useEffect(() => {
    // Get user's orgId
    const fetchUserOrgId = async () => {
      try {
        const userDocRef = doc(db, 'c3_users', currentUser.uid);
        const userDoc = await getDoc(userDocRef);
        if (userDoc.exists()) {
          setUserOrgId(userDoc.data().orgId);
        }
      } catch (error) {
        console.error('Error fetching user orgId:', error);
      }
    };
    fetchUserOrgId();
  }, [currentUser.uid, db]);

  return (
    <div className="comms-container">
      <div className="d-flex justify-content-between align-items-center mb-4">
        <h3 className="h5 mb-0">Crisis Communications</h3>
      </div>

      <Row gutter={[16, 16]}>
        <Col span={24}>
          <Card>
            <Tabs activeKey={activeTab} onChange={setActiveTab}>
              <TabPane
                tab={
                  <Tooltip title="Send bulk SMS to staff filtered by location and role during crisis response">
                    <span>
                      <TeamOutlined />
                      Bulk SMS to Staff
                    </span>
                  </Tooltip>
                }
                key="bulk_sms"
              >
                <BulkSMSPanel 
                  orgId={userOrgId}
                  currentUserRole={currentUser?.role || 'org_admin'}
                  isReadOnly={true} // Phase 1: Read-only mode
                  crisisContext={{
                    incidentId: incidentId,
                    type: 'crisis_communication'
                  }}
                  onStaffFiltered={(results) => {
                    console.log('Staff filtered in crisis context:', results);
                    // Optional: Log crisis communication filtering
                    if (results.totalCount > 0) {
                      createIncidentLog(
                        incidentId,
                        ACTIVITY_TYPES.COMMUNICATION_PREPARED,
                        `Filtered ${results.totalCount} staff for potential bulk SMS communication`,
                        { 
                          filters: results.filters,
                          staffCount: results.totalCount,
                          phase: 'phase1_preview'
                        },
                        currentUser
                      );
                    }
                  }}
                />
              </TabPane>
            </Tabs>
          </Card>
        </Col>
      </Row>
    </div>
  );
};

export default CommsTab; 